import { Component, DOCUMENT, Renderer2, computed, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter } from "rxjs/operators";
import { Store } from "@ngxs/store";
import { DASHBOARD_TOUR_STEPS, DASHBOARD_ASSISTANT_STEP } from "../../shared/page-tour/tour-steps/dashboard-tour-steps";
import { COURSE_SESSIONS_TOUR_STEPS } from "../../shared/page-tour/tour-steps/course-sessions-tour-steps";
import { MY_JOURNEY_TOUR_STEPS } from "../../shared/page-tour/tour-steps/my-journey-tour-steps";
import { TourStep, PageTourComponent } from "../../shared/page-tour/page-tour.component";
import { GroupState } from "../../states/group-state";
import { Group } from "@sdk/lib/types/group";
import { SanctuarySidebarComponent } from "../../shared/sanctuary-sidebar/sanctuary-sidebar.component";
import { FooterComponent } from "../../shared/footer/footer.component";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: "app-full-layout",
    templateUrl: "./full-layout.component.html",
    imports: [
        SanctuarySidebarComponent,
        PageTourComponent,
        RouterOutlet,
        FooterComponent,
        TranslocoPipe,
    ],
})
export class FullLayoutComponent {
  private router = inject(Router);
  private document = inject(DOCUMENT);
  private renderer = inject(Renderer2);
  private _store = inject(Store);
  private readonly _group = this._store.selectSignal(GroupState as any) as () => Group | null;

  readonly dashboardSteps = computed<TourStep[]>(() => {
    if (!this._group()?.course?.assistant_url) return DASHBOARD_TOUR_STEPS;
    const lastStep = DASHBOARD_TOUR_STEPS[DASHBOARD_TOUR_STEPS.length - 1];
    return [...DASHBOARD_TOUR_STEPS.slice(0, -1), DASHBOARD_ASSISTANT_STEP, lastStep];
  });
  readonly courseSessionsSteps = COURSE_SESSIONS_TOUR_STEPS;
  readonly myJourneySteps = MY_JOURNEY_TOUR_STEPS;

  constructor() {
    this.renderer.addClass(this.document.body, "vertical-layout");
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
      });
  }
}
